import React, { useEffect, useState, useRef } from 'react'
import Plot from 'react-plotly.js';
import { useWebSocketConnection } from '../../services/connectionContext/connectionContext';
import { Box, Typography } from '@mui/material';

export const RawDataPlot = React.memo(({ title, socketRawDataEvent, xlabel, ylabel }) => {
  const { eventEmitter } = useWebSocketConnection();

  const [rawData, setRawData] = useState([]);

  // CHANGED: Ref zum Puffern der Daten
  const rawDataRef = useRef([]);

  useEffect(() => {
    // CHANGED: Handler, der eingehende Daten nur puffert:
    const handleData = (incomingData) => {
      rawDataRef.current = incomingData;
    };

    // Abonnieren des Events, aber statt setRawData direkt => handleData
    eventEmitter.on(socketRawDataEvent, handleData);

    // CHANGED: Aktualisierung in Intervallen (z.B. 10x pro Sekunde)
    const intervalId = setInterval(() => {
      setRawData(rawDataRef.current);
    }, 100); // 100ms = 10 Hz

    return () => {
      eventEmitter.off(socketRawDataEvent, handleData);
      clearInterval(intervalId);
    }
  }, [eventEmitter, socketRawDataEvent]);

  return (
    <Box>
      <Typography>
        {title}
      </Typography>
      <Plot
        style={{ width: "100%", minHeight: 400 }}
        className='raw-data-plot'
        data={rawData}
        layout={{
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)',
          autosize: true,
          showlegend: true,
          legend: { "orientation": "h" },
          xaxis: {
            title: { text: xlabel },
            showgrid: true,
            showline: true,
            gridwidth: 1,
            gridcolor: '#bbbbbb'
          },
          yaxis: {
            title: { text: ylabel },
            showgrid: true,
            showline: true,
            gridwidth: 1,
            gridcolor: '#bbbbbb'
          }
        }}
      />
    </Box>
  )
});
